import tw from 'twin.macro'

export const PanelGrid = tw.div`flex flex-col gap-4 sm:gap-6`
